import React, { createRef, useEffect, useRef } from "react";
import PopUpItem from "../PopUp/PopUpItem";
import PopupArcode from "../PopUp/PopUpArcode";
import PopUpOther, { CreditCode } from "../PopUp/PopUpOther";
import { ReDate } from "../PopUp/PopUpS_Cscustorder";
import { genURL, genpostURL, genURLTEST } from "../_getjson";
import { parseJwt } from "../parseJWT";
import PopUpwarehouse from "../PopUp/PopUpwarehouse";
import CheckUser from "../CustomFunction/Csuser/GetUser";
import ChackAr from "../CustomFunction/Csar/GetAr";
import CheckBrabchname from "../CustomFunction/Branch/Checkname";
import CheckDepartmentname from "../CustomFunction/Department/Checkname";
import _group from "./../_source/groupConfig/_groupConfig";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Panel,
  MenuItem,
} from "react-bootstrap";
import "./../_css/App.css";
import { checkData } from "../_source/checkDatainput";
import { checkunit } from "../_source/checkUnit";
import axios from "axios";
import Backdrop from "../Components/CustomBackdrop/Barckdrop";
import Snackbar from "../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import cheackprice from "../CustomFunction/Product/ChackPrice";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import SelectDatas from "../PopUp/SelectData";
import MaterialUIPickers from "../Components/CustomDatepicker/MaterialUIPickers";
import Topbar from "../Components/Customtopbar/Topbar";
import FullScreenDialog from "../PopUp/FullScreendialogs/FullScreen";
import CustomInputtext from "../Components/CustomInput/Inputtext";
import Repostview from "../Components/Reportview/Repostview";
// import { engineVersion } from "mobile-device-detect"; // unused
import FullScreenDialognew from "../Components/CustomDialogs/Fullscreendialog";
import Rechecked from "./Components/Rechecked";
import InputTemplate from "../Components/CustomInput/InputTemplate/inputtemplate";
import { Grid } from "@mui/material";

import CustomARInput from "../Components/CustomARInput/CustomARInput";
import { AsyncTypeahead } from "react-bootstrap-typeahead";

const rowtable = 300;
const defaultcode = "0";
const reporturl =
  "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FPSMT_Quotation&standAlone=true";
const listmenu = [["-", "-"]];
export default class index extends React.Component {
  optionsselect = [
    { value: "1", label: "Chocolate" },
    { value: "2", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  constructor(props) {
    super(props);
    this.CustomerCode = createRef();
    this.CustomerName = createRef();
    this.DeliNumber = createRef();
    this.Groupdata_code = createRef();
    this.Groupdata = createRef();
    this.VALIDDAY = createRef();
    this.EXCHANGERATE = createRef();
    this.QUOTRELATE = createRef();
    this.CreditCode_code = createRef();
    this.CreditCode = createRef();
    this.Csuser_code = createRef();
    this.Csuser = createRef();
    this.SumPrice = createRef();
    this.TaxPersen = createRef();
    this.TaxPrice = createRef();
    this.valueTax = createRef();
    this.Department_code = createRef();
    this.Department = createRef();
    this.DISCWORD = createRef();
    this.DISCAMOUNT = createRef();
    this.Branch_code = createRef();
    this.Branch = createRef();
    this.ProductValue = createRef();
    this.ValueExcept = createRef();
    this.pricetype = createRef();
    this.TotalPrice = createRef();
    this.REMARK = createRef();
    this.REMARK2 = createRef();
    this._hprefix = createRef();
    this._prefix = createRef();
    this.UserFieldsname = createRef();
    this.UserFieldslastname = createRef();
    this.UserFields3 = createRef();
    this.UserFields4 = createRef();
    this.UserFields5 = createRef();
    this.UserFields6 = createRef();

    //ข้อมูลเพิ่มเติม ( User's Field)
    this.machineNumber = createRef();
    this.MTSerialNo = createRef();
    this.mileageNumber = createRef();
    this.Rnregist = createRef();

    this.state = {
      TBLastClick: -1,
      siteCodeUser: "",
      deprositState: 0,
      discount_s_row: "",
      discount_s_cellValue: "",
      value: { label: this.props.val, value: this.props.val },
      Groupdata_txt: "",
      Department_txt: "",
      Branch_txt: "",
      show1: false,
      openBackdrop: false,
      autoClose: 3600,
      color: "warning",
      messagealert: "",
      PriceType_code: defaultcode,
      brandname: "",
      model: "",
      colorcar: "",
      PROJECT: "",
      provenance: "",
      checkenableInput: [],
      defaultvaluewarehouse: "",
      defaultwarehouse: "",
      defaultlocetion: "",
      CustomerCode: "",
      Docdate: "",
    };
  }
  async componentDidMount() {
    console.log(
      "componentDidMount",
      JSON.parse(localStorage.getItem("checkoftxt"))
    );
    //เช็คเปิดปิด textbox
    await this.setState({
      checkenableInput: JSON.parse(localStorage.getItem("checkoftxt")),
    });

    this.setState({
      provenance: window.location.hostname === "localhost" ? "" : "Web",
    });

    this.setState({ _moto: _group["moto"] });
    this.setState({ _parts: _group["parts"] });
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });

    this.onAddValue("Csuser", SITECODESTR.User.CODE);
    if (localStorage.getItem("UsernameTH")) {
      this.Csuser.current.value = localStorage.getItem("UsernameTH");
    }
    this.setRow(rowtable);
    this.DefaultTxt();
    this.onAddValue("Branch", SITECODESTR.User.SITECODE);
  }

  DefaultTxt = () => {
    this.VALIDDAY.current.value = 0;
    this.EXCHANGERATE.current.value = "1.0000000";
    this.TaxPersen.current.value = parseFloat(7.0).toFixed(2);
    this.DISCWORD.current.value = "";
    this.mileageNumber.current.value = parseFloat(0).toFixed(2);
    this.setState({ SYSCREATE: this.CalendarOnChange(new Date()) });
    this.setState({ EXPIREDATE: this.CalendarOnChange(new Date()) });
  };
  saveData = async () => {
    const parameter = new URLSearchParams();
    var datatable = [];
    var s = [];
    var row = this.state.products;
    for (var i = 0; i < row.length && row[i].productcode; i++) {
      if (row[i].stocktype === 0) {
        console.log(row[i].stocktype);
        console.log(row[i].location);
        if (!row[i].location) {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณาเลือกคลัง" });
          return;
        }
        if (!row[i].warehouse) {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณาเลือกตำแหน่งเก็บ" });
          return;
        }
        if (Number(row[i].quantity) <= 0) {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({
            messagealert: "สินค้า " + row[i].productcode + " ไม่ได้กำหนดปริมาณ",
          });
          return;
        }
      }

      for (var i = 0; i < row.length; i++) {
        if (row[i].productcode) {
          datatable[i] = {
            ProductCode: row[i].productcode,
            ProductName: row[i].productname,
            Warehouse: row[i].warehouse,
            Location: row[i].location,
            Unitcode: row[i].unitcode,
            Quantity: row[i].quantity,
            SalePrice: row[i].saleprice,
            DiscountWord: row[i].discountword ? row[i].discountword : "",
            DiscountAmount: row[i].discountamount ? row[i].discountamount : "",
            Amount: row[i].amount,
            ProductSet: row[i].PRODUCTSET,
            StockType: row[i].stocktype ? row[i].stocktype : "0",
          };
          s.push(datatable[i]);
        }
      }
    }
    /* Success */
    parameter.append("listitem", JSON.stringify(s));
    parameter.append("DOCNO", this.DeliNumber.current.value);
    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("UPDATEUSER", localStorage.getItem("Username"));
    parameter.append("SALECODE", localStorage.getItem("Username"));
    parameter.append("OWNERCODE", localStorage.getItem("Username"));
    parameter.append("REMARK", this.REMARK.current.value);
    parameter.append("REMARK2", this.REMARK2.current.value);
    parameter.append("ARCODE", this.state.CustomerCode);
    parameter.append("ARNAME", this.CustomerName.current.value);
    parameter.append("CREDITCODE", this.CreditCode_code.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("SYSCREATE", this.state.SYSCREATE);
    parameter.append("VALIDDAY", this.VALIDDAY.current.value);
    parameter.append("VALIDDATE", this.state.VALIDDATE);
    parameter.append("EXPIREDATE", this.state.EXPIREDATE);
    parameter.append("TAXTYPE", this.state.PriceType_code);
    parameter.append("DEPARTMENT", this.Department_code.current.value);
    parameter.append("SITECODE", this.Branch_code.current.value);
    parameter.append(
      "DISCWORD",
      this.DISCWORD.current.value ? this.DISCWORD.current.value + "%" : ""
    );
    parameter.append("DISCAMOUNT", this.DISCAMOUNT.current.value);
    parameter.append("QUOTRELATE", this.QUOTRELATE.current.value);
    parameter.append(
      "SUMAMOUNT1",
      checkData("money", this.SumPrice.current.value)
    );
    parameter.append(
      "SUMAMOUNT2",
      checkData("money", this.ValueExcept.current.value)
    );
    parameter.append("EXCHANGERATE", this.EXCHANGERATE.current.value);
    parameter.append("TOTALAMOUNT", this.valueTax.current.value);
    parameter.append("BATHTOTALAMOUNT", this.valueTax.current.value);
    parameter.append("DEBTAMOUNT", this.TotalPrice.current.value);
    parameter.append("BATHDEBTAMOUNT", this.TotalPrice.current.value);
    parameter.append("AFTERDISC", this.ProductValue.current.value);
    parameter.append("BATHSUMAMOUNT1", this.ProductValue.current.value);
    parameter.append("TAXRATE", this.TaxPersen.current.value);
    parameter.append("TAXAMOUNT", this.TaxPrice.current.value);
    parameter.append("BATHTAXAMOUNT", this.TaxPrice.current.value);
    parameter.append("PROJECT", this.state.PROJECT);
    parameter.append("COMPNAME", "");

    //ข้อมูลเพิ่มเติม ( User's Field)
    parameter.append("MachineNo", this.machineNumber.current.value);
    parameter.append("SerialNo", this.MTSerialNo.current.value);
    parameter.append("MTKilometer", this.mileageNumber.current.value);
    parameter.append("Brandcode", checkData("text", this.state.brandname));
    parameter.append("Modelcode", checkData("text", this.state.model));
    parameter.append("Colorcode", checkData("text", this.state.colorcar));
    parameter.append("Rnregist", this.Rnregist.current.value);

    var Uststus = true;
    for (var pair of parameter.entries()) {
      console.log(pair);
      if (pair[0] === "ARCODE" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" });
        return;
      } else if (pair[0] === "DOCGROUP" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกกลุ่มข้อมูล" });
        return;
      } else if (pair[0] === "DEPARTMENT" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกแผนก" });
        return;
      } else if (pair[0] === "PRODUCT" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกสินค้า" });
        return;
      } else if (pair[0] === "UserFieldsname" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกชื่อลูกค้า" });
        return;
      } else if (pair[0] === "UserFieldslastname" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกนามสกุลลูกค้า" });
        return;
      }
    }
    if (Uststus === true) {
      this.setState({ openBackdrop: true });
      var url = "CSQUOT/Save?=";
      //  axios.post(genpostURLTEST("/Save?="), parameter).then(res => {
      axios
        .post(genpostURL(url), parameter)
        .then((res) => {
          if (res.data.status === "success") {
            this.setState({ color: "success" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกสำเร็จ" });
            this.setState({ opensnackbar: false });
            this.setState({
              openReportFullScreenDialog: true,
              titleReportFullScreenDialog: "พิมพ์ใบเสนอราคา",
              docno: res.data.docno,
            });
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกไม่สำเร็จ" });
            this.setState({ openBackdrop: false });
          }
        })
        .catch((error) => {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
          this.setState({ openBackdrop: false });
        })
        .finally((_) => {
          this.setState({ openBackdrop: false });
        });
    }
  };
  ResetThisPage = () => {
    this.setState({ openBackdrop: false });
    location.reload();
  };
  /*----------------------------------------------------------------------------------------------------------------------------*/
  SelectSetData = (data1, data2) => {
    switch (data1) {
      case "PriceType":
        this.setState({ PriceType_code: data2 });
        setTimeout(() => {
          this.ReLoadData();
        }, 500);
        break;
      case "_prefix":
        this._prefix.current.value = data2;
        this._hprefix.current.value = data2;
        break;
      case "Calendar1":
        this.setState({ VALIDDATE: data2 });
        this.setState({ EXPIREDATE: data2 });
        break;
      case "Calendar2":
        this.setState({ EXPIREDATE: data2 });
        break;
      case "Calendar":
        this.setState({ SYSCREATE: data2 });
        break;
      case "PROJECT":
        this.setState({ PROJECT: data2 });
        break;
      default:
        break;
    }
  };
  confirm = () => {
    var col = this.state.products;
    for (var i = 0; i < col.length; i++) {
      if (col[i].productcode !== undefined) {
        this.setState({ show1: true });
      }
    }
  };
  Get_PopUparcode = (
    CustomerCode,
    CustomerName,
    Creditcode,
    Texttype,
    Address,
    _accountcdoe,
    _Prefix,
    _Arname,
    _Surname
  ) => {
    this.CloseDialog(false);
    this.setState({ customer1: CustomerCode });
    this.state.CustomerCode = CustomerCode;
    this.CustomerName.current.value = CustomerName;
    setTimeout(() => {
      this._pricetype(Texttype);
      this.CreditCode_code.current.value = Creditcode;
      this.CreditCode.current.value = CreditCode(Creditcode);
    }, 30);
    this.confirm();
  };
  _pricetype = (Texttype) => {
    this.setState({ PriceType_code: String(Texttype) });
    setTimeout(() => {
      this.Cal_Price();
    }, 500);
  };
  Get_PopUpOther = (value) => {
    this.CloseDialog(false);
    var data = value.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        this.Groupdata_code.current.value = data[0];
        this.Groupdata.current.value = data[1];
        this.setState({ Groupdata_txt: data[1] });
        this.onClickDocNo();
        // this.onAddValue("Groupdata", data[0]);
        break;
      case "Department":
        this.Department_code.current.value = data[0];
        this.setState({ Department_txt: data[1] });
        this.Department.current.value = data[1];
        break;
      case "CreditCode":
        this.CreditCode_code.current.value = data[0];
        this.CreditCode.current.value = data[1];
        break;
      case "Branch":
        this.Branch_code.current.value = data[0];
        this.setState({ Branch_txt: data[1] });
        this.Branch.current.value = data[1];
        break;
      default:
        break;
    }
  };
  CalendarOnChange = (data, DateUp) => {
    var Backup = "";
    var today = new Date(data);
    if (DateUp) {
      today.setDate(today.getDate() + DateUp);
    }
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + (yyyy + 543);
    setTimeout(() => {
      Backup = this.state.MenuItem;
      this.setState({ MenuItem: "" });
    }, 0);
    setTimeout(() => {
      this.setState({ MenuItem: Backup });
    }, 10);
    return today;
  };
  /*------------------------------------------------center------------------------------------------------*/
  _cellButton(cell, row, enumObject, rowIndex) {
    var btn = this.state.products[rowIndex].btn1;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={() => this.Switch_PopUpItem("Search_Table")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }
  _chkload = (cell, row, enumObject, rowIndex) => {
    return (
      <div>
        <i id={"load" + rowIndex}>{rowIndex + 1}</i>
      </div>
    );
  };
  _cellButton_btn_DeliDate = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.products[rowIndex].btn_DeliDate1;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  _cellButton_btn_DeliDate1 = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.products[rowIndex].btn_DeliDate2;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = {
        C0: i + 1,
      };
    }
    this.setState({ products: data });
  };
  onRowClick = (row, col, id) => {
    this.setState({ cellValue: row.productcode });
    this.setState({ WHRow: id });
    var Pr = this.state.products;
    var j = rowtable;
    // ไม่ให้คีย์ข้ามแถว
    this.setState({ col1: false });
    this.setState({ col: false });
    // จำนวนเต็มเวลาคลิก
    let quantity = row.quantity,
      saleprice = row.saleprice;
    console.log(col, row);
    if (col === 10 && quantity !== "" && quantity !== undefined) {
      row.quantity = parseFloat(quantity).toFixed(0);
    } else if (col === 11 && saleprice !== "" && saleprice !== undefined) {
      row.saleprice = parseFloat(saleprice).toFixed(0);
    }
    for (var i = 0; i < Pr.length; i++) {
      Pr[i].btn1 = 0;
      Pr[i].btn_DeliDate1 = 0;
      Pr[i].btn_DeliDate2 = 0;
    }
    // หาจากล่างขึ้นบน
    for (var i = this.state.products.length - 1; i >= 0; i--) {
      //หา แถวที่ว่างบนสุดใน products Table
      if (!this.state.products[i].productcode) {
        j = i;
      }
    }
    // BTN ค้นหาได้เฉพาะในแถว
    if (
      (col === 1 && j === id) ||
      (col === 1 && Pr[id].productcode !== undefined)
    ) {
      this.setState({ col1: true });
      Pr[id].btn1 = 1;
    } else if (col === 4 && row.productcode) {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_DeliDate1 = 1;
    } else if (col === 6 && row.productcode) {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_DeliDate2 = 1;
    }
    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.productcode !== "undefined" && row.productcode !== "") {
      this.setState({ col: true });
      // BTN วันที่
      Pr[id].btn_DeliDate = 1;
    }
    setTimeout(() => {
      this.setState({ products: Pr });
    }, 100);
  };
  /* เช็คคลังสินค้า */
  onAfterSaveCell = (row, cellName, cellValue) => {
    var cellValue1 = this.state.cellValue;
    // ทศนิยม 2 ตำแหน่ง ปริมาณ
    if (cellName === "quantity" && row.quantity) {
      if (row.PRODUCTSET === "1") {
        for (
          let i = 0;
          i < this.state.products.length && this.state.products[i].productcode;
          i++
        ) {
          console.log(
            this.state.products[i].PARENTCODE,
            "===",
            row.productcode
          );
          if (this.state.products[i].PARENTCODE === row.productcode) {
            this.state.products[i].quantity = parseFloat(
              (
                Number(this.state.products[i].quantity1) * Number(row.quantity)
              ).toFixed(2)
            );
          }
        }
      }
      row.quantity = parseFloat(row.quantity).toFixed(2);
      console.log(row.productcode);
      this.ReLoadData2(row.productcode);
    }
    if (cellName === "saleprice" && row.saleprice !== "") {
      row.saleprice = parseFloat(cellValue).toFixed(2);
      this.ReLoadData();
    }

    if (
      cellName === "productcode" &&
      cellValue !== "" &&
      cellValue1 !== cellValue
    ) {
      var col = this.state.products;
      col[row.C0 - 1] = [];
      col[row.C0 - 1].C0 = row.C0;
      col[row.C0 - 1].btn1 = row.btn1;
      this.setState({ products: col });
      this.AddDataTable(cellValue, row.C0 - 1);
    } else if (row.productcode === undefined || row.productcode === "") {
      setTimeout(() => {
        this.ReLoadData();
      }, 250);
    } else if (
      (cellName === "quantity" && cellValue !== "") ||
      (cellName === "discountword" && cellValue !== "") ||
      (cellName === "saleprice" && cellValue !== "")
    ) {
      var col = this.state.products;
      this._chkGroup(col[row.C0 - 1].productcode, col[row.C0 - 1].C0);
      setTimeout(() => {
        let str = "" + cellValue;
        var res = str.match("%");
        if (res) {
          let newstr = str.split("%");
          if (newstr[0] * 1 > 100) {
            col[col[row.C0 - 1].C0 - 1].discountword = "100%";
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                "สินค้ารหัส " +
                col[row.C0 - 1].productcode +
                "ส่วนลดใส่ได้ไม่เกิน 100% ",
            });
          }
        } else {
          console.log(str);
        }
        setTimeout(() => {
          this.setState({ products: col });
        }, 100);
        setTimeout(() => {
          this.ReLoadData();
        }, 200);
      }, 300);
      setTimeout(() => {
        this.Cal_Price();
      }, 200);
    }
  };
  _chkGroup(val, row) {
    // เช็คกลุ่มสินค้า
    try {
      var lastCode = this.state.codeGroup.substring(7, 8);
      this.setState({ lastCode_s_: lastCode });
    } catch (error) {
      this.setState({ lastCode_s_: 99 });
    }
    if (lastCode === 8) {
      let url =
        "CSPRODUCT/CHKGroup?code=" +
        val +
        "&user=" +
        localStorage.getItem("Username");
      axios.get(genURL(url), { timeout: 1800 }).then((res) => {
        if (res.data.length > 0) {
          for (var i = 0; i < res.data.length; i++) {
            this.setState({ groupNumber: res.data[i].MAINGROUP });
          }
        }
      });
    } else {
      this.setState({ groupNumber: 99 });
    }
  }
  Get_PopUpItem = (Code, data, stockCode) => {
    this.CloseDialog(false);
    this.AddDataTable(Code, this.state.TBLastClick - 1, data, stockCode);
  };
  AddDataTable = async (ItemCode, row) => {
    var col = this.state.products;
    /* รหัสสินค้าซ้ำกันเพิ่มจำนวน ปริมาณ */
    for (var i = 0; i < col.length; i++) {
      if (col[i].productcode === ItemCode) {
        col[i].quantity = parseFloat(Number(col[i].quantity) + 1).toFixed(2);
        this.setState({ products: col });
        this.ReLoadData();
        return;
      }
    }
    var url =
      "CSPRODUCT/GetAllProductcode?code=" +
      ItemCode +
      "&user=" +
      localStorage.getItem("Username");
    console.log(genURL(url));
    axios
      .get(genURL(url), { timeout: 3600 })
      .then(async (ref) => {
        console.log(ref.data);
        var j = 0;
        if (row > -1) {
          j = row;
        } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
          j = this.state.TBLastClick - 1;
        } else {
          for (var i = this.state.products.length - 1; i >= 0; i--) {
            // หาจากล่างขึ้นบน
            if (!this.state.products[i].productcode) {
              j = i;
            }
          }
        }
        if (ref.data.length > 0) {
          for (var i = 0; i < ref.data.length; i++) {
            var STKWAREHOUSE = "0";
            var url1 =
              "STKWAREHOUSE/Search?productcode=" + ref.data[i].PRODUCTCODE;
            //  console.log(genURL(url1));
            await axios.get(genURL(url1), { timeout: 3600 }).then((res) => {
              if (res.data.length > 0) {
                STKWAREHOUSE = "1";
              }
            });
            console.log(STKWAREHOUSE);

            var unit = "";
            await checkunit(ref.data[i].UNITCODE).then((data) => {
              unit = data;
            });
            var saleprice = 0;
            await cheackprice(
              ref.data[i].PRODUCTCODE,
              1,
              this.state.CustomerCode,
              ref.data[i].UNITCODE,
              ref.data[i].ITEMTAXTYPE,
              this.state.SYSCREATE,
              this.CreditCode_code.current.value
            )
              .then((res) => {
                console.log(res);
                if (res !== undefined) {
                  saleprice = parseFloat(res).toFixed(2);
                }
              })
              .catch((err) => {
                console.log(err);
              });
            col[j] = {
              C0: j + 1,
              productcode: ref.data[i].PRODUCTCODE,
              btn1: col[0].btn1,
              productname: ref.data[i].PRODUCTNAME,
              duedate:
                this.state.SYSCREATE != this.CalendarOnChange(new Date())
                  ? this.state.SYSCREATE
                  : this.CalendarOnChange(new Date()),
              warehouse: this.state.defaultwarehouse,
              location: this.state.defaultlocetion,
              unitname: unit,
              unitcode: ref.data[i].UNITCODE,
              quantity: ref.data[i].QUANTITY
                ? ref.data[i].QUANTITY
                : (0).toFixed(2),
              quantity1: ref.data[i].QUANTITY ? ref.data[i].QUANTITY : 0,
              saleprice:
                Number(ref.data[i].UNITPRICE) > 0
                  ? ref.data[i].UNITPRICE
                  : saleprice,
              discountword: ref.data[i].DISCWORD,
              discountamount: "",
              amount: "",
              btn_DeliDate: 1,
              stocktype: ref.data[i].STOCKTYPE,
              PARENTCODE: ref.data[i].PARENTCODE,
              PRODUCTSET:
                ref.data[i].PARENTCODE === ref.data[0].PRODUCTCODE
                  ? "2"
                  : String(ref.data[i].PRODUCTSET),
              STKWAREHOUSE: STKWAREHOUSE,
            };
            j++;
            this.setState({ products: col });
            this.ReLoadData();
          }
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูลสินค้าในคลังสาขาของคุณ" });
        }
      })
      .finally(() => {
        this.setState({ openBackdrop: false });
      })
      .catch(() => {
        this.setState({ openBackdrop: false });
      });
    this.Cal_Price();
    setTimeout(() => {
      document.getElementById("TableLoadItem").innerHTML = "";
    }, 5000);
  };

  // search ราคาขาย
  ReLoadData2 = async (productcode) => {
    let col = this.state.products;
    var data = "";
    await cheackprice(
      productcode,
      Number(col[this.state.WHRow].quantity),
      this.state.CustomerCode.trim(),
      col[this.state.WHRow].unitcode,
      this.state.PriceType_code,
      this.state.SYSCREATE,
      this.CreditCode_code.current.value
    )
      .then(async (res) => {
        if (res !== undefined) {
          data = await res;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    col[this.state.WHRow].saleprice = parseFloat(data).toFixed(2);
    this.setState({});
    this.ReLoadData({ products: col });
  };
  AddDataTable2 = async () => {
    var col = this.state.products;
    var data = "0.00";
    for (let i = 0; i < col.length; i++) {
      if (col[i].productcode !== undefined) {
        await cheackprice(
          col[i].productcode,
          parseFloat(col[i].quantity).toFixed(0),
          this.state.CustomerCode.trim(),
          col[i].unitcode,
          this.state.PriceType_code,
          this.state.SYSCREATE,
          this.CreditCode_code.current.value
        )
          .then(async (res) => {
            if (res !== undefined) {
              data = await res;
            }
          })
          .catch((err) => {
            console.log(err);
          });
        col[i].saleprice = parseFloat(data).toFixed(2);
      }
    }
    this.setState({ products: col });
  };
  // เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
  ReLoadData = () => {
    var col = this.state.products;
    var NewCol = [];
    var j = 0;

    for (var i = 0; i < col.length; i++) {
      if (col[i].productcode) {
        NewCol[j] = col[i];
        NewCol[j].C0 = j + 1;
        NewCol[j].btn_DeliDate = 1;
        if (col[i].discountword === "-") {
          NewCol[j].discountword = col[i].saleprice * col[i].quantity;
        } else if (col[i].discountword === "") {
          NewCol[j].discountword = 0;
        } else if (
          col[i].discountword * 1 >
          col[i].saleprice * col[i].quantity * 1
        ) {
          NewCol[j].discountword = col[i].saleprice * col[i].quantity;
        }
        let str = "" + NewCol[j].discountword;
        var res = str.match("%");
        if (res) {
          if (col[i].productcode !== "") {
            let newstr = str.split("%");
            NewCol[j].amount = parseFloat(
              col[i].saleprice * col[i].quantity -
                col[i].saleprice * col[i].quantity * (newstr[0] / 100)
            ).toFixed(2);
            NewCol[j].discountamount = parseFloat(
              col[i].saleprice * col[i].quantity * (newstr[0] / 100)
            ).toFixed(2);
          }
        } else {
          if (col[i].productcode !== "") {
            if (
              col[i].discountword * 1 >
              col[i].saleprice * col[i].quantity * 1
            ) {
              NewCol[j].discountword = col[i].saleprice * col[i].quantity * 1;
            }
            let sum =
              col[i].saleprice * col[i].quantity * 1 -
              NewCol[j].discountword * 1;
            NewCol[j].quantity = parseFloat(NewCol[j].quantity).toFixed(2);
            NewCol[j].amount = sum.toFixed(2);
            NewCol[j].discountamount = NewCol[j].discountword
              ? parseFloat(NewCol[j].discountword).toFixed(2)
              : (0).toFixed(2);
          }
        }
        j++;
      }
    }

    for (var i = j; i < col.length; i++) {
      NewCol[j] = { C0: j + 1 };
      j++;
    }
    setTimeout(() => {
      this.Cal_Price();
    }, 300);
    this.setState({ products: NewCol });
    /* this.DISCWORD.current.value = ""; */
    this.DISCAMOUNT.current.value = parseFloat(0).toFixed(2);
  };
  /*------------------------------------------------------คำนวณยอดเงิน----------------------------------------------------------------------*/
  Cal_Price = (e) => {
    var SumPriceProduct = 0.0;
    var SumPriceProduct1 = 0.0;
    var TaxPersen = Number(this.TaxPersen.current.value);
    var TaxPersen1 = 100 + TaxPersen;
    var DiscountPersen = this.DISCWORD.current.value
      ? Number(this.DISCWORD.current.value)
      : 0;
    for (var i = 0; i < this.state.products.length; i++) {
      if (
        this.state.products[i].amount &&
        this.state.products[i].PRODUCTSET !== "2"
      ) {
        SumPriceProduct1 += parseFloat(this.state.products[i].amount);
        this.DISCAMOUNT.current.value = parseFloat(
          (SumPriceProduct1 * DiscountPersen) / 100
        ).toFixed(2);
        SumPriceProduct = SumPriceProduct1 - this.DISCAMOUNT.current.value;
      }
    }
    this.setState({ allpriceforTax_: SumPriceProduct });
    var DISCAMOUNT = 0;
    if (this.DISCAMOUNT.current.value) {
      DISCAMOUNT = parseFloat(this.DISCAMOUNT.current.value).toFixed(2);
    }
    this.DISCAMOUNT.current.value = parseFloat(DISCAMOUNT).toFixed(2);
    this.TaxPersen.current.value = parseFloat(TaxPersen).toFixed(2);
    //--------------------------------------เช็คประเภทภาษี------------------------------------------
    if (this.state.PriceType_code === "0") {
      //ไม่รวมภาษี
      this.ProductValue.current.value = parseFloat(SumPriceProduct).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat(
        (SumPriceProduct * 7) / 100
      ).toFixed(2);
      this.SumPrice.current.value = parseFloat(SumPriceProduct).toFixed(2);
      this.TotalPrice.current.value = parseFloat(
        (SumPriceProduct * 7) / 100 + SumPriceProduct
      ).toFixed(2);
      this.valueTax.current.value = parseFloat(
        (SumPriceProduct * 7) / 100 + SumPriceProduct
      ).toFixed(2);
      this.ValueExcept.current.value = "0.00";
    } else if (this.state.PriceType_code === "1") {
      //รวมภาษี
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat(
        (SumPriceProduct * TaxPersen) / TaxPersen1
      ).toFixed(2);
      this.ProductValue.current.value = parseFloat(
        SumPriceProduct - Number(this.TaxPrice.current.value)
      ).toFixed(2);
      this.SumPrice.current.value = SumPriceProduct.toFixed(2);
      this.TotalPrice.current.value = SumPriceProduct.toFixed(2);
      this.valueTax.current.value = SumPriceProduct.toFixed(2);
      this.TaxPrice.current.value = parseFloat(
        SumPriceProduct - Number(this.ProductValue.current.value)
      ).toFixed(2);
      this.ValueExcept.current.value = "0.00";
    } else {
      this.ProductValue.current.value = parseFloat(SumPriceProduct).toFixed(2);
      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value =
        "0.00"; /* parseFloat((SumPriceProduct * TaxPersen) / 100).toFixed(2); */
      this.SumPrice.current.value = SumPriceProduct.toFixed(2);
      this.TotalPrice.current.value = SumPriceProduct.toFixed(2);
      this.valueTax.current.value = SumPriceProduct.toFixed(2);
      this.ValueExcept.current.value = "0.00";
    }
    var ValueExcept = 0;
    if (this.ValueExcept.current.value) {
      ValueExcept = parseFloat(this.ValueExcept.current.value).toFixed(2);
    }
  };
  Cal_Price1 = (e) => {
    if (e.key === "Enter" && e.target.value !== "") {
      this.Cal_Price();
    }
  };
  /*-------------------------------------------popup------------------------------------------------------------------------------*/
  Switch_PopUpItem = (e) => {
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    //title
    this.setState({ titleFullScreenDialog: "ค้นหาสินค้า-product" });
  };
  Switch_PopupArcode = (e) => {
    //ชื่อ
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    //title
    this.setState({ titleFullScreenDialog: "ค้นหาลูกค้า-AR" });
  };
  Switch_OtherPopup = (e) => {
    //ชื่อ
    this.setState({ OtPopupType: e });
    //ชื่อ
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    if (e === "Groupdata") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" });
    }
    if (e === "Department") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" });
    }
    if (e === "Branch") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" });
    }
    if (e === "CreditCode") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-creditcode" });
    }
  };
  /*--------------------------------------------------------พิเศษ------------------------------------------------------------*/
  SwitchValue = (ref, type) => {
    console.log("switchvalue");
    if (type === "EnterEvent") {
      var M_data = this[ref].current.value;
      var D_data = this[ref + "_code"].current.value;
      this[ref].current.value = D_data;
      this[ref + "_code"].current.value = M_data;
    } else {
      if ((type === "IN" && this.state.LastRef !== ref) || type === "OUT") {
        var M_data = this[ref].current.value;
        var D_data = this[ref + "_code"].current.value;
        this[ref].current.value = D_data;
        this[ref + "_code"].current.value = M_data;
        this.setState({ LastRef: ref });
      }
      if (type === "OUT" && this.state.LastRef === ref) {
        this.onAddValue(ref, M_data);
        this.setState({ LastRef: "" });
      }
    }
  };
  onChangeData = (e, val) => {
    var Ref = this.state.LastRef;
    if (e.key === "Enter") {
      // this.onAddValue(Ref, val).then((res) => {
      //   this.SwitchValue(Ref, "EnterEvent");
      // });
    }
  };
  /*ค้นหา ดึงข้อมูลมาไว้ใน table */
  reChecked = async (RowData) => {
    // console.log("RowData", RowData)
    this.CloseDialog(false);
    await this.setRow(rowtable);
    this.setState({ _saveStatus: true });
    let url = genURL("CSQUOT/Pageserachmain?code=" + RowData[0].docNo);
    let urltest = genURLTEST("/Pageserachmain?code=" + RowData[0].docNo);
    axios.get(url, { timeout: 5000 }).then((res) => {
      //  console.log("reChecked", res.data);
      // arCode:"1480500108042"
      // arName: "นายธนวัต ตะวังทัน"
      // createUser : "thanawat"
      // debtAmount : "100.00"
      // department : "01"
      // docDate : "15/01/2025"
      // docNo  : "SQ1006-680121-001"
      // fontColor : "GREEN"
      // id :  1
      // project : null
      // refDocNo : null
      // remark : ""
      // saleName : "ธนวัต"
      // upDate  : "2025-01-22T14:56:11.7Z"
      // upDateUser : "thanawat

      if (res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          //     console.log(res.data[i])
          this.setState({
            defaultvaluewarehouse:
              "รหัสคลัง: " +
              res.data[i].SITECODE +
              "  รหัสที่เก็บ: " +
              res.data[i].SITECODE +
              "001",
          });
          if (res.data[i].ARCODE) {
            this.setState({
              CustomerCode: res.data[i].ARCODE,
            });
          }
          if (res.data[i].ARNAME) {
            this.CustomerName.current.value = res.data[i].ARNAME;
          }
          if ((res.data[i].SHIPDATE = "null")) {
            this.setState({ SYSCREATE: "" });
          }

          this.DeliNumber.current.value = res.data[i].DOCNO;
          this.onAddValue("Groupdata", res.data[i].DOCGROUP, "Y").then((No) => {
            this.DeliNumber.current.value = res.data[i].DOCNO;
          });
          this.Groupdata_code.current.value = res.data[i].DOCGROUP;
          this.CreditCode_code.current.value = res.data[i].CREDITCODE;
          this.CreditCode.current.value = CreditCode(res.data[i].CREDITCODE);
          this.setState({
            VALIDDATE: ReDate(res.data[i].VALIDDATE),
            Docdate: ReDate(res.data[i].DOCDATE),
            SYSCREATE: ReDate(res.data[i].SYSCREATE),
          });
          this.REMARK.current.value = res.data[i].REMARK;
          this.REMARK2.current.value = res.data[i].REMARK2;
          this.QUOTRELATE.current.value = res.data[i].QUOTRELATE;
          this.onAddValue("Department", res.data[i].DEPARTMENT);
          this.onAddValue("Branch", res.data[i].SITECODE);
          this.onAddValue("Csuser", res.data[i].SALECODE);
          this.TaxPersen.current.value = res.data[i].TAXRATE;
          this.TaxPrice.current.value = res.data[i].TAXAMOUNT;
          this.SumPrice.current.value = res.data[i].SUMAMOUNT1;
          this.ProductValue.current.value = res.data[i].AFTERDISC;
          this.DISCWORD.current.value = res.data[i].DISCWORD;
          this.DISCAMOUNT.current.value = res.data[i].DISCAMOUNT;
          this.valueTax.current.value = res.data[i].TOTALAMOUNT;
          this.ValueExcept.current.value = res.data[i].SUMAMOUNT2;
          this.TotalPrice.current.value = res.data[i].BATHDEBTAMOUNT;

          this.machineNumber.current.value = res.data[i].MachineNo;
          this.MTSerialNo.current.value = res.data[i].SerialNo;
          this.mileageNumber.current.value = res.data[i].MTKilometer;
          this.checkSearch("Brandcode", res.data[i].Brandcode);
          this.checkSearch("Modelcode", res.data[i].Modelcode);
          this.checkSearch("Colorcode", res.data[i].Colorcode);
          this.Rnregist.current.value = res.data[i].Rnregist;

          let TAXTYPE = res.data[i].TAXTYPE;
          setTimeout(() => {
            this._pricetype(TAXTYPE);
            try {
              this.ReLoadData();
            } catch (error) {
              console.log(error);
            }
          }, 50);
        }
      }
    });
    /* Pageserachsub */
    var url1 = "CSQUOT/Pageserachsub?code=" + RowData[0].docNo;
    console.log(genURL(url1));
    await axios.get(genURL(url1), { timeout: 1800 }).then(async (res) => {
      if (res.data.length > 0) {
        var data = this.state.products;
        for (var i = 0; i < res.data.length; i++) {
          //    console.log("ss"+res.data[i].UNITCODE);
          var unit = "";
          await checkunit(res.data[i].UNITCODE).then((data) => {
            unit = data;
          });
          data[i].productcode = res.data[i].PRODUCTCODE;
          data[i].productname = res.data[i].PRODUCTNAME;
          data[i].DeliDate = ReDate(res.data[i].SHIPDATE);
          data[i].warehouse = res.data[i].SITECODE;
          data[i].location = res.data[i].LOCATION;
          data[i].unitcode = res.data[i].UNITCODE;
          data[i].unitname = unit;
          data[i].quantity = res.data[i].QUANTITY;
          data[i].saleprice = res.data[i].AMOUNT;
          data[i].discountword = res.data[i].DISCAMOUNT;
          data[i].amount = res.data[i].NETAMOUNT;
          console.log(i, res.data.length);
          if (i === res.data.length - 1) {
            await this.setState({ products: data });
            this.Cal_Price();
          }
        }
      }
    });
  };

  checkSearch = (name, code) => {
    if (code) {
      var _url = "";
      switch (name) {
        case "Brandcode":
          _url = "CSPDSUBGROUP2/getCode?top=1&code=" + code;
          break;
        case "Modelcode":
          _url = "CSPDSUBGROUP4/getCode?top=1&code=" + code;
          break;

        case "Colorcode":
          _url = "/CSPDSUBGROUP5/getCode?top=1&code=" + code;
          break;
      }
      console.log(genURL(_url));
      axios.get(genURL(_url), { timeout: 60000 }).then(async (res) => {
        console.log(res);
        if (res.data.length > 0) {
          var element = "";
          for (let index = 0; index < res.data.length; index++) {
            if (index === 0) {
              element =
                (await res.data[index].CODE) + " | " + res.data[index].MYNAMETH;
              if (name === "Brandcode") {
                this.setState({ selectedbrandname: [element] });
                this.setState({ brandname: res.data[index].CODE });
              }
              if (name === "Modelcode") {
                this.setState({ selectedmodel: [element] });
                this.setState({ model: res.data[index].CODE });
              }
              if (name === "Colorcode") {
                this.setState({ selectedcolor: [element] });
                this.setState({ colorcar: res.data[index].CODE });
              }
            }
          }
        }
      });
    }
  };

  ///-------------------------------------save data --------------------------
  _connectsaveData = () => {
    var row = this.state.products;
    if (!this.state.CustomerCode) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาตรวจสอบรหัสลูกค้า" });
      return;
    }
    if (!this.Groupdata_code.current.value) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาตรวจสอบกลุ่มข้อมูล" });
      return;
    }
    if (!this.DeliNumber.current.value) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาตรวจสอบเลขที่ใบเสนอราคา" });
      return;
    }
    if (!this.CreditCode_code.current.value) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาตรวจสอบรหัสเครดิต" });
      return;
    }
    if (!this.Department_code.current.value) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาตรวจสอบแผนก" });
      return;
    }
    if (!this.Branch_code.current.value) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาตรวจสอบสาขา" });
      return;
    }

    for (let i = 0; i < row.length && row[i].productcode; i++) {
      if (!row[i].warehouse) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกคลัง" });
        return;
      }
      if (!row[i].location) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกตำแหน่งเก็บ" });
        return;
      }
      if (!row[i].quantity) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกตำแหน่งเก็บ" });
        return;
      }
      if (Number(row[i].quantity) < 1) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "ปริมาณต้องไม่เท่ากับ 0.00" });
        return;
      }
      // if (row[i].STKWAREHOUSE === "0" && row[i].stocktype) {
      //   this.setState({ opensnackbar: true })
      //   this.setState({ color: "warning" })
      //   this.setState({ icon: ErrorIcon })
      //   this.setState({ messagealert: "สินค้า " + row[i].productcode + " ไม่ได้ระบุคลังหรือตำแหน่งเก็บ หรือระบุไม่ถูกต้อง" })
      //   return
      // }
    }
    if (
      !this.SumPrice.current.value ||
      this.SumPrice.current.value === "0.00"
    ) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "รวมจำนวนเงินต้องมีค่ามากกว่า 0.00" });
      return;
    }

    this.saveData();
  };
  onClick = (e) => {
    if (e.target.value) {
      switch (e.target.name) {
        case "Groupdata":
          this.Groupdata.current.value = this.Groupdata_code.current.value;
          break;
        case "Department":
          this.Department.current.value = this.Department_code.current.value;
          break;
        case "Branch":
          this.Branch.current.value = this.Branch_code.current.value;
          break;
        case "mileageNumber":
          this.mileageNumber.current.value = Number(e.target.value);
          break;
        default:
          break;
      }
    }
  };
  onBlur = (e) => {
    console.log("start" + e.target.name);
    console.log(this.state.CustomerCode);
    console.log("end" + e.target.name);
    switch (e.target.name) {
      case "Groupdata":
        this.Groupdata.current.value = this.state.Groupdata_txt;
        break;
      case "Department":
        this.Department.current.value = this.state.Department_txt;
        break;
      case "Branch":
        this.Branch.current.value = this.state.Branch_txt;
        break;
      case "mileageNumber":
        this.mileageNumber.current.value = Number(e.target.value).toFixed(2);
        break;
      case "VALIDDAY":
        var dateP = Number(this.VALIDDAY.current.value);
        this.setState({ VALIDDATE: this.CalendarOnChange(new Date(), dateP) });
        this.setState({ EXPIREDATE: this.CalendarOnChange(new Date(), dateP) });
        break;
      case "arCode": // ลูกค้า
        this.onAddValue("CustomerCode", e.target.value);
      default:
        break;
    }
  };

  onChange = (e) => {
    if (!e.target.value) {
      switch (e.target.name) {
        case "CustomerCode":
          this.CustomerName.current.value = "";
          break;
        case "Groupdata":
          this.Groupdata_code.current.value = "";
          this.setState({ Groupdata_txt: "" });
          this.DeliNumber.current.value = "";
          break;
        case "Department":
          this.Department_code.current.value = "";
          this.setState({ Department_txt: "" });
          break;
        case "Branch":
          this.Branch_code.current.value = "";
          this.setState({ Branch_txt: "" });
          break;
        default:
          break;
      }
    }
  };
  /* เช็คข้อมูลตรงกับตารางหรือไม่ตรง */
  onClickDocNo = async () => {
    if (!this.Groupdata_code.current.value) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "ไม่พบข้อมูล" });
      // this.dialog.showAlert('กรุณาเลือกกลุ่มข้อมูล');   return;
    }
    if (this.Groupdata_code.current.value) {
      var Url =
        "CSMAXDOC/MAXDOC?tablename=CSQUOT&code=" +
        this.Groupdata_code.current.value.trim();
      axios
        .get(genURL(Url), { timeout: 3600 })
        .then((res) => {
          console.log("====================================");
          console.log(res.data.maxdoc);
          console.log("====================================");
          if (res.data.maxdoc.length > 0) {
            this.DeliNumber.current.value = res.data.maxdoc;
          } else {
            this.DeliNumber.current.value = "";
          }
        })
        .catch((error) => {
          this._chkload("Error" + error);
        });
    } else {
      this.DeliNumber.current.value = "";
    }
  };
  _blurinput = () => {
    var _txtselect = "";
    var _code = "";
    switch (this.state.chkfocus) {
      case "brandname":
        _txtselect = "" + this.state.selectedbrandname;
        _code = _txtselect.split("|");
        this.setState({ brandname: _code[0].trim() });
        break;
      case "model":
        _txtselect = "" + this.state.selectedmodel;
        _code = _txtselect.split("|");
        this.setState({ model: _code[0].trim() });
        break;
      case "color":
        _txtselect = "" + this.state.selectedcolor;
        _code = _txtselect.split("|");
        console.log(_code);
        this.setState({ colorcar: _code[0].trim() });
        break;
    }
  };
  _handleSearch = (query) => {
    this.setState({ isLoading: true });
    var _url = "";
    var _code = "";
    var _name = "";
    switch (this.state.chkfocus) {
      case "brandname":
        _url = "CSPDSUBGROUP2/getAll?top=500";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
      case "model":
        _url = "CSPDSUBGROUP4/getAll?top=500";
        _code = "CODE";
        _name = "MYNAMETH";
        break;

      case "color":
        _url = "/CSPDSUBGROUP5/getAll?top=500";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
    }
    return axios.get(genURL(_url), { timeout: 60000 }).then((res) => {
      console.log(res);
      if (res !== "error") {
        var element = [];
        for (let index = 0; index < res.data.length; index++) {
          element.push(res.data[index][_code] + " | " + res.data[index][_name]);
        }
        console.log(element);
        this.setState({
          isLoading: false,
          options: element,
        });
      }
      setTimeout(() => {
        console.log(this.state.options);
      }, 300);
      return "SS";
    });
  };
  //------------------------------- คำนวนส่วนลดรวม--------------------------------------
  Get_warehouse = async (data) => {
    this.CloseDialog(false);
    var DataValue = data.split("|");
    var Pr = this.state.products;
    var r = this.state.WHRow;
    console.log(r, "sssss");
    Pr[r].warehouse = DataValue[0];
    Pr[r].location = DataValue[2];
    Pr[r].quantity = parseFloat(1).toFixed(2);

    setTimeout(() => {
      this.setState({ products: Pr });
      this.checkStkwarehouse(this.state.WHRow);
    }, 100);
  };
  // เช็คสต๊อค
  checkStkwarehouse = (row) => {
    var col = this.state.products;
    var urll =
      "CSSTKWAREHOUSE/checkstockqty?productcode=" +
      col[row].productcode +
      "&warehouse=" +
      this.state.productcodeinrow1 +
      "&location=" +
      col[row].location;
    var chki = 0;

    axios
      .get(genURL(urll), { timeout: 1800 })
      .then((res) => {
        console.log(res);
        var chkloc = 0;
        for (var i = 0; i < res.data.length; i++) {
          chkloc = chkloc + 1;
          chki = chki + 1;
          // col[row].MaxUnit = res.data[i].STOCKQTY;
          /* col[row].location = res.data[i].LOCATION; */
          col[row].quantity = (1).toFixed(2);
        }
        setTimeout(() => {
          this.setState({ products: col });
        }, 100);
      })
      .then((_) => {
        setTimeout(() => {
          this.ReLoadData();
        }, 500);
      });
  };
  Switch_PopUpwarehouse = (type) => {
    switch (type) {
      case "setwarehousetable":
        if (this.state.productcodeinrow !== "") {
          //ชื่อ
          this.setState({ typeFullScreenDialog: type });
          //open
          this.setState({ openFullScreenDialog: true });
          //title
          this.setState({ titleFullScreenDialog: "เลือกคลังและตำแหน่งเก็บ" });
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบรหัสสินค้าในแถวที่ท่านเลือก" });
          return;
        }

        break;
    }
  };
  onKeyDown = (e) => {
    console.log(e.target.name);
    if (e.key === "Enter") {
      if (e.target.name === "Groupdata") {
        this.onAddValue("Groupdata", e.target.value);
      }
      if (e.target.name === "arCode") {
        this.onAddValue("CustomerCode", e.target.value);
      }
      if (e.target.name === "Department") {
        this.onAddValue("Department", e.target.value);
      }
      if (e.target.name === "Branch") {
        this.onAddValue("Branch", e.target.value);
      }
    }
  };
  onAddValue = async (type, value, Fix) => {
    console.log("type::::", type, "value:::", value);
    switch (type) {
      case "Groupdata":
        let Url = "CSDOCGROUP/Code?tablename=CSQUOT&code=" + value;
        console.log(genURL(Url));
        await axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
          if (res.data.length > 0) {
            for (let index = 0; index < res.data.length; index++) {
              this.Groupdata_code.current.value = res.data[index].CODE;
              this.Groupdata.current.value = res.data[index].MYNAMETH;
              this.setState({ Groupdata_txt: res.data[index].MYNAMETH });
            }
            if (Fix !== "Y") {
              let Url1 = "CSMAXDOC/MAXDOC?tablename=CSQUOT&code=" + value;
              axios.get(genURL(Url1), { timeout: 3600 }).then((res) => {
                if (res.data) {
                  this.DeliNumber.current.value = res.data["maxdoc"];
                }
                var type = this.DeliNumber.current.value.substring(0, 2);
                console.log(type);
                if (type === "SO") {
                  this.setState({ DOCTYPE: 0 });
                } else {
                  this.setState({ DOCTYPE: 1 });
                }
              });
            }
          } else {
            this.Groupdata_code.current.value = "";
            this.Groupdata.current.value = "";
          }
        });
        break;
      case "CustomerCode":
        console.log("CustomerCode", value);
        if (value !== "") {
          await ChackAr(value)
            .then((result) => {
              console.log(result);
              if (result !== "") {
                let data = result.split("|");
                this.CustomerName.current.value = data[0];
                setTimeout(() => {
                  this._pricetype(data[5]);
                  this.CreditCode_code.current.value = data[1];
                  this.CreditCode.current.value = CreditCode(data[1]);
                }, 30);
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({
                  messagealert: "ไม่พบข้อมูล",
                  CustomerCode: "",
                });
                this.CustomerName.current.value = "";
              }
            })
            .catch((err) => {
              this.setState({
                CustomerCode: "",
              });
              this.CustomerName.current.value = "";
              console.log(err);
            });
        } else {
          console.log("CustomerCode else");

          this.CustomerName.current.value = "";
        }
        break;
      case "Csuser":
        await CheckUser(value)
          .then(async (result) => {
            if (result !== "") {
              this.Csuser_code.current.value = await value;
              this.Csuser.current.value = await result;
            } else {
              this.setState({ opensnackbar: true });
              this.setState({ color: "warning" });
              this.setState({ icon: ErrorIcon });
              this.setState({ messagealert: "ไม่พบข้อมูลพนักงาน" });
              this.Csuser_code.current.value = "";
              this.Csuser.current.value = "";
            }
          })
          .catch((err) => {
            this.Csuser_code.current.value = "";
            this.Csuser.current.value = "";
            console.log(err);
          });
        break;
      case "Department":
        await CheckDepartmentname(value)
          .then((result) => {
            if (result !== "") {
              this.Department_code.current.value = value;
              this.Department.current.value = result;
              this.setState({ Department_txt: result });
            } else {
              this.setState({ opensnackbar: true });
              this.setState({ color: "warning" });
              this.setState({ icon: ErrorIcon });
              this.setState({ messagealert: "ไม่พบข้อมูล" });
              this.Department_code.current.value = "";
              this.Department.current.value = "";
              this.setState({ Department_txt: "" });
            }
          })
          .catch((err) => {
            this.Department_code.current.value = "";
            this.Department.current.value = "";
            this.setState({ Department_txt: "" });
            console.log(err);
          });
        break;
      case "Branch":
        await CheckBrabchname(value)
          .then((result) => {
            if (result !== "") {
              this.Branch_code.current.value = value;
              this.Branch.current.value = result;
              this.setState({ Branch_txt: result });
            } else {
              this.setState({ opensnackbar: true });
              this.setState({ color: "warning" });
              this.setState({ icon: ErrorIcon });
              this.setState({ messagealert: "ไม่พบข้อมูล" });
              this.Branch_code.current.value = "";
              this.Branch.current.value = "";
              this.setState({ Branch_txt: "" });
            }
          })
          .catch((err) => {
            this.Branch_code.current.value = "";
            this.Branch.current.value = "";
            this.setState({ Branch_txt: "" });
            console.log(err);
          });
        break;
      default:
        break;
    }
  };
  onClickTopbar = (e) => {
    console.log(e);
    switch (e) {
      case "save":
        this._connectsaveData();
        break;
      case "new":
        this.ResetThisPage();
        break;
      case "print":
        console.log("print");
        break;
      case "search":
        //ชื่อ
        this.setState({ typeFullScreenDialog: e });
        //open
        this.setState({ openFullScreenDialog: true });
        //title
        this.setState({ titleFullScreenDialog: "บันทึกใบเสนอราคา" });
        break;
      default:
        break;
    }
  };
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e });
  };
  propsvalue = (data) => {
    if (data.source === "CSWAREHOUSEALL") {
      this.setState({ defaultwarehouse: data.warehouse });
      this.setState({ defaultlocetion: data.location });
    }
  };
  rowStyleFormat = (row, rowIdx) => {
    // console.log(row, rowIdx);
    let color = "";
    if (row) {
      if (row.PRODUCTSET === "1") {
        color = "blue";
      } else if (row.PRODUCTSET === "2") {
        color = "#22AF19";
      }
    }
    return { color: color };
  };

  CloseReportDialog = (e) => {
    this.setState({ openReportFullScreenDialog: e });

    this.ResetThisPage();
    // setTimeout(() => {
    //   this.setState({ openBackdrop: false })
    //   window.location.reload();
    // }, 500);
  };

  ResCustomARInput = async (e) => {
    this.setState({ CustomerCode: e });
  };
  onSelectData = () => {
    this.onAddValue("CustomerCode", this.state.CustomerCode);
  };
  render() {
    const type = this.state.typeFullScreenDialog;
    return (
      <div
        className="PSApp"
        onBlur={this.onBlur}
        onKeyDown={this.onKeyDown}
        onClick={this.onClick}
        onChange={this.onChange}
      >
        {/* print bill */}
        <FullScreenDialognew
          open={this.state.openReportFullScreenDialog}
          title={this.state.titleReportFullScreenDialog}
          CloseDialog={(e) => this.CloseReportDialog(e)}
        >
          <Repostview
            url={`${process.env.REACT_APP_REPORTURL}${reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${this.state.docno}`}
          />
        </FullScreenDialognew>
        <Backdrop open={this.state.openBackdrop} />
        <FullScreenDialog
          open={this.state.openFullScreenDialog}
          title={this.state.titleFullScreenDialog}
          closeDialog={(e) => this.CloseDialog(e)}
        >
          {type === "search" ? (
            <Rechecked Dataselect={this.reChecked} />
          ) : // <PopUpSearchDoc closePopup={e => this.CloseDialog(e)} Get_Popup={this._serchDoc} from="CSQUOT" />
          null}
          {type === "Groupdata" ||
          type === "Department" ||
          type === "Branch" ||
          type === "CreditCode" ? (
            <PopUpOther
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this.Get_PopUpOther}
              from="CSQUOT"
              userSite={this.state.siteCodeUser}
            />
          ) : null}
          {type === "Search_Table" ? (
            <PopUpItem
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUpItem={this.Get_PopUpItem}
              userSite={this.state.siteCodeUser}
              from="CSQUOT"
            />
          ) : null}
          {type === "Search_ARCode" ? (
            <PopupArcode
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUparcode={this.Get_PopUparcode}
            />
          ) : null}
          {type === "setwarehousetable" ? (
            <PopUpwarehouse
              closePopup={(e) => this.CloseDialog(e)}
              type="setdefaultwarehouse"
              Get_PopUpOther={this.Get_warehouse}
              productcodeinrow={this.state.productcodeinrow}
              productcodeinrow1={this.state.productcodeinrow1}
              from="CSQUOT"
            />
          ) : null}
        </FullScreenDialog>
        <Topbar
          listmenu={listmenu}
          title="บันทึกใบเสนอราคา"
          onClick={(e) => this.onClickTopbar(e)}
        />
        <div className="PSAppfrom">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <CustomARInput
                resData={(e) => this.ResCustomARInput(e)}
                keyDown={(e) => this.onKeyDown(e)}
                onBlur={(e) => this.onBlur(e)}
                onSelect={(e) => this.onSelectData(e)}
                defaultValue={this.state.CustomerCode}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <InputTemplate
                title={"ชื่อลูกค้า"}
                children={
                  <>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      ref={this.CustomerName}
                      style={{ marginTop: "0px" }}
                    />
                  </>
                }
                // icon={<PersonIcon fontSize="14px" />}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <InputTemplate
                title={"กลุ่มข้อมูล"}
                children={
                  <>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.Groupdata_code}
                      style={{ marginTop: "0px" }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="Groupdata"
                      ref={this.Groupdata}
                      tabIndex={2}
                      style={{ marginTop: "0px" }}
                    />
                    <span
                      id="iconGroupdata"
                      className="input-group-addon icon"
                      onClick={this.Switch_OtherPopup.bind(null, "Groupdata")}
                      style={{ marginTop: "0px" }}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </>
                }
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <MaterialUIPickers
                title="วันที่เสนอราคา"
                DateValue={(e) => this.SelectSetData("Calendar", e)}
                defaultdate={this.state.Docdate}
                open={this.state.checkenableInput["DOCDATE"]}
                sx={{ height: "40px", marginTop: "5px" }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <InputTemplate
                title={"เลขที่ใบเสนอราคา"}
                children={
                  <input
                    type="text"
                    className="form-control"
                    ref={this.DeliNumber}
                    readOnly={this.state.OpenTAXNO}
                  />
                }
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <InputTemplate
                title={"รหัสเครดิต"}
                children={
                  <>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.CreditCode_code}
                    />
                    <input
                      type="text"
                      className="form-control"
                      ref={this.CreditCode}
                      onKeyPress={this.onChangeData.bind(null, "CreditCode")}
                      onBlur={this.SwitchValue.bind(null, "CreditCode", "OUT")}
                      onClick={this.SwitchValue.bind(null, "CreditCode", "IN")}
                      disabled
                    />
                    <span
                      id="iconCreditCode"
                      className="input-group-addon icon"
                      onClick={this.Switch_OtherPopup.bind(null, "CreditCode")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </>
                }
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <SelectDatas
                origin="PriceType" // ประเภท
                valueSelect={(e) => this.SelectSetData("PriceType", e)} // รับค่ากลับ
                title="ประเภทราคา"
                defaultselect={this.state.PriceType_code} // ค่าเริ่มต้นของ ประเภทราคา
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <InputTemplate
                title={"ยืนราคา(วัน)"}
                children={
                  <>
                    <input
                      type="text"
                      className="form-control"
                      name="VALIDDAY"
                      ref={this.VALIDDAY}
                      style={{ width: "32px", marginTop: "-0px" }}
                    />
                    <MaterialUIPickers
                      DateValue={(e) => this.SelectSetData("Calendar1", e)}
                      defaultdate={this.state.VALIDDATE}
                      hiddenlabal={true}
                    />
                  </>
                }
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <MaterialUIPickers
                title="หมดอายุ"
                DateValue={(e) => this.SelectSetData("Calendar2", e)}
                defaultdate={this.state.EXPIREDATE}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
              <CustomInputtext
                title="คลังเริ่มต้น"
                value={this.state.defaultvaluewarehouse}
                disabledvalue={true}
                of_title={false}
                of_btn={false}
                source={"CSWAREHOUSEALL"}
                propsvalue={this.propsvalue}
              />
            </Grid>
          </Grid>
        </div>
        <div className="container-fluid">
          <div>
            <Modal show={this.state.show1} size="sm" /* onHide={true}  */>
              <ModalHeader style={{ borderRadius: "10px 10px 0px 0px" }}>
                <div className="PopUpOtherDivH1">
                  <i className="fas " style={{ color: "black" }}>
                    {" "}
                    ปรับราคา{" "}
                  </i>
                </div>
                <div className="PopUpOtherDivH2">
                  <i
                    className="fas fa-times"
                    style={{ color: "white" }}
                    onClick={() => {
                      this.setState({ show1: false });
                    }}
                  ></i>
                </div>
              </ModalHeader>
              <ModalBody style={{ fontSize: "20px", left: "12px" }}>
                ต้องการปรับราคาขายต่อหน่วยใหม่หรือไม่!{" "}
              </ModalBody>
              <ModalFooter style={{ borderRadius: "0px 0px 10px 10px" }}>
                <Button
                  variant="secondary"
                  style={{ width: "60px", height: "36px", fontSize: "20px" }}
                  onClick={() => {
                    this.AddDataTable2();
                    this.setState({ show1: false });
                  }}
                >
                  {" "}
                  ใช่{" "}
                </Button>
                <Button
                  variant="primary"
                  style={{ width: "60px", height: "36px", fontSize: "20px" }}
                  onClick={() => {
                    this.setState({ show1: false });
                  }}
                >
                  {" "}
                  ไม่ใช่{" "}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
        <div className="PSAppTable">
          <BootstrapTable
            data={this.state.products}
            trClassName="trClassName"
            tableHeaderclassName="trClassName"
            options={{ noDataText: "...", onRowClick: this.onRowClick }}
            cellEdit={{
              //แก้ไข
              mode: "click",
              blurToSave: true,
              beforeSaveCell: this.onBeforeSaveCell,
              afterSaveCell: this.onAfterSaveCell,
            }}
            trStyle={this.rowStyleFormat}
            // ไม่ให้พิมพ์ข้อมูลได้
            // keyBoardNav={{ enterToEdit: true }}
            height="400"
          >
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="C0"
              isKey
              width="35px"
              dataAlign="center"
              dataFormat={this._chkload.bind(this)}
            ></TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              colSpan="2"
              dataAlign="center"
              width="150"
              className="colbuttomhidden"
            >
              {" "}
              รหัสสินค้า
            </TableHeaderColumn>
            <TableHeaderColumn
              row="1"
              dataField="productcode"
              editable={this.state.col1}
              dataAlign="left"
              width="120"
            >
              {" "}
              <div align="center"></div>
            </TableHeaderColumn>
            <TableHeaderColumn
              row="1"
              dataField="Btn1"
              editable={false}
              dataAlign="left"
              width="30"
              dataFormat={this._cellButton.bind(this)}
              columnClassName="columnClassNameFormat1"
            >
              {" "}
              <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="productname"
              editable={false}
              dataAlign="left"
              width="140"
            >
              {" "}
              <div align="center">ชื่อสินค้า</div>
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              colSpan="2"
              dataAlign="center"
              width="120"
              className="colbuttomhidden"
            >
              คลัง
            </TableHeaderColumn>
            <TableHeaderColumn
              row="1"
              dataField="warehouse"
              editable={this.state.col}
              dataAlign="center"
              width="90"
            ></TableHeaderColumn>
            <TableHeaderColumn
              row="1"
              dataField="btn_warehouse"
              editable={false}
              dataAlign="center"
              width="30"
              dataFormat={this._cellButton_btn_DeliDate.bind(this)}
              columnClassName="columnClassNameFormat1"
            >
              {" "}
              <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              colSpan="2"
              dataAlign="center"
              width="120"
              className="colbuttomhidden"
            >
              {" "}
              ตำแหน่งเก็บ
            </TableHeaderColumn>
            <TableHeaderColumn
              row="1"
              dataField="location"
              editable={this.state.col}
              dataAlign="center"
              width="90"
            >
              {" "}
            </TableHeaderColumn>
            <TableHeaderColumn
              row="1"
              dataField="btn_location"
              editable={false}
              dataAlign="center"
              width="30"
              dataFormat={this._cellButton_btn_DeliDate1.bind(this)}
              columnClassName="columnClassNameFormat1"
            ></TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="unitname"
              editable={false}
              dataAlign="center"
              width="90"
            >
              หน่วย
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="unitcode"
              editable={false}
              width="90"
              hidden
            >
              {" "}
              unitcode{" "}
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="quantity"
              editable={this.state.col}
              dataAlign="center"
              width="90"
            >
              ปริมาณ
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="saleprice"
              editable={
                this.state.col && this.state.checkenableInput["UNITPRICE"] > 0
              }
              dataAlign="right"
              width="90"
            >
              ราคาขาย
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="discountword"
              editable={this.state.col}
              dataAlign="right"
              width="90"
            >
              ลด
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="discountamount"
              editable={false}
              dataAlign="right"
              width="90"
            >
              จำนวนเงิน(ส่วนลด)
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="amount"
              editable={false}
              dataAlign="right"
              width="90"
            >
              <div align="center"> จำนวนเงิน </div>
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="PRODUCTSET"
              editable={false}
              dataAlign="right"
              width="150"
              hidden
            >
              <div align="center" hidden>
                {" "}
                PRODUCTSET{" "}
              </div>
            </TableHeaderColumn>
            <TableHeaderColumn
              row="0"
              rowSpan="2"
              dataField="stocktype"
              width="90"
              hidden
            >
              stocktype
            </TableHeaderColumn>
            {/* <TableHeaderColumn row="0" rowSpan="2" dataField="MaxUnit" width="90" >MaxUnit</TableHeaderColumn> */}
          </BootstrapTable>
        </div>
        <Grid container>
          <Col xs={12} sm={8} md={8} lg={8}>
            <Row className="show-grid">
              {/*  col ที่ 1 */}
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="form-group">
                  <div className="input-group">
                    <span className="input-group-addon">พนักงานขาย</span>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.Csuser_code}
                    />
                    <input
                      type="text"
                      className="form-control"
                      ref={this.Csuser}
                      disabled
                    />
                    <span id=" " className="input-group-addon icon">
                      <i
                        className="fas fa-sync-alt"
                        onClick={() =>
                          this.onAddValue("Csuser", this.state.siteCodeUser1)
                        }
                      ></i>
                    </span>
                  </div>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <span className="input-group-addon">แผนก </span>
                    <input
                      type="text"
                      className="form-control hidden"
                      ref={this.Department_code}
                    />
                    <input
                      type="text"
                      className="form-control "
                      name="Department"
                      ref={this.Department}
                      tabIndex={4}
                    />
                    <span
                      id="CSDEPARTMENT"
                      className="input-group-addon icon"
                      onClick={this.Switch_OtherPopup.bind(null, "Department")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </div>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <SelectDatas
                      origin="PROJECT" // โครงการ
                      valueSelect={(e) => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                      title="โครงการ"
                      defaultselect={this.state.PROJECT} // ค่าเริ่มต้นของ โครงการ
                    />
                  </div>
                </div>
              </Col>
              {/*  col ที่ 1.2 */}
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="row">
                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon"> สาขา </span>
                      <input
                        type="text"
                        className="form-control hidden"
                        ref={this.Branch_code}
                      />
                      <input
                        type="text"
                        className="form-control"
                        name="Branch"
                        ref={this.Branch}
                        tabIndex={5}
                      />
                      <span
                        id="iconBranch"
                        className="input-group-addon icon"
                        onClick={this.Switch_OtherPopup.bind(null, "Branch")}
                      >
                        <i>
                          {" "}
                          <ArrowDropDownRoundedIcon fontSize="small" />
                        </i>
                      </span>
                    </div>
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">สกุลเงิน </span>
                      <input
                        type="text"
                        className="form-control"
                        ref={this.pricetype}
                        defaultValue="บาท"
                      />
                      <span className="input-group-addon icon">
                        <i></i>
                      </span>
                    </div>
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">
                        อัตราแลกเปลี่ยน{" "}
                      </span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.EXCHANGERATE}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="show-grid">
              {/*  col ที่ 1 */}
              <Col xs={12} sm={12} md={12} lg={12}>
                <Row className="show-grid">
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <div className="row">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">หมายเหตุ</span>
                          <input
                            type="text"
                            className="form-control"
                            ref={this.REMARK}
                            tabIndex={5}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="show-grid">
              {/*  col ที่ 1 */}
              <Col xs={12} sm={12} md={12} lg={12}>
                <Row className="show-grid">
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <div className="row">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">หมายเหตุ2</span>
                          <input
                            type="text"
                            className="form-control"
                            ref={this.REMARK2}
                            tabIndex={5}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="show-grid">
              {/*  col ที่ 1 */}
              <Col xs={12} sm={12} md={12} lg={12}>
                <Row className="show-grid">
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <div className="row">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">
                            สัมพันธ์กับเลขที่
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            ref={this.QUOTRELATE}
                            tabIndex={5}
                          />
                          <span id=" " className="input-group-addon icon">
                            <i
                              className="fas fa-sync-alt"
                              onClick={() =>
                                this.onAddValue(
                                  "Csuser",
                                  this.state.siteCodeUser1
                                )
                              }
                            ></i>
                          </span>
                          <span className="input-group-addon">
                            {"<<"} วิเคราะห์
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          {/*  col ที่ 2 */}
          <Col xs={12} sm={4} md={4} lg={4}>
            <Row className="show-grid">
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="row ">
                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">รวมจำนวนเงิน</span>
                      <input
                        type=""
                        className="form-control Price"
                        ref={this.SumPrice}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">ส่วนลด</span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.DISCWORD}
                        // onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); }}
                        onKeyDown={this.Cal_Price1}
                        onBlur={this.Cal_Price.bind(null)}
                      />
                      <span className="input-group-addon icon">
                        {" "}
                        <i className="fas fa-percentage"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.DISCAMOUNT}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">มูลค่าสินค้า</span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.ProductValue}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">ภาษีมูลค่าเพิ่ม</span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.TaxPersen}
                        onClick={(e) => {
                          e.target.value = parseFloat(e.target.value).toFixed(
                            0
                          );
                        }}
                        onKeyDown={this.Cal_Price1}
                        onBlur={this.Cal_Price.bind(null)}
                      />
                      <span className="input-group-addon icon">
                        {" "}
                        <i className="fas fa-percentage"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.TaxPrice}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon ">มูลค่ารวมภาษี</span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.valueTax}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon"> มูลค่ายกเว้น</span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.ValueExcept}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                    <div className="input-group  col-xs-12 col-sm-12 col-lg-12 col-md-12">
                      <span className="input-group-addon">
                        {" "}
                        รวมเงินทั้งสิ้น
                      </span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.TotalPrice}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Row className="show-grid">
              <Col xs={12} sm={12} md={12} lg={12}>
                <Panel>
                  <Panel.Heading>
                    <Panel.Title componentClass="h5">
                      ข้อมูลเพิ่มเติม ( User's Field){" "}
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Row className="show-grid">
                        <Col xs={12} sm={12} md={4} lg={4}>
                          <div className="row ">
                            <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon">
                                  {" "}
                                  เลขเครื่อง:{" "}
                                </span>
                                <input
                                  type="text"
                                  className="form-control "
                                  ref={this.machineNumber}
                                  tabIndex={16}
                                />
                              </div>
                            </div>
                            <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon">
                                  {" "}
                                  หมายเลขตัวถัง
                                </span>
                                <input
                                  type="text"
                                  className="form-control "
                                  ref={this.MTSerialNo}
                                  tabIndex={17}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4}>
                          <div className="row ">
                            <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon">
                                  {" "}
                                  เลขไมล์
                                </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="mileageNumber"
                                  ref={this.mileageNumber}
                                  tabIndex={15}
                                />
                              </div>
                            </div>
                            <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon">
                                  {" "}
                                  ยี่ห้อ
                                </span>
                                <AsyncTypeahead
                                  id="my-typeahead-id"
                                  {...this.state}
                                  labelKey="brandname"
                                  selected={this.state.selectedbrandname}
                                  onChange={(selectedbrandname) =>
                                    this.setState({ selectedbrandname })
                                  }
                                  onBlur={this._blurinput}
                                  onSearch={this._handleSearch}
                                  minLength={1}
                                  placeholder="ค้นหายี่ห้อ..."
                                  renderMenuItemChildren={(option, props0) => (
                                    <MenuItem key={option}> {option} </MenuItem>
                                  )}
                                  onFocus={() =>
                                    this.setState({ chkfocus: "brandname" })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4}>
                          <div className="row ">
                            <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon">
                                  {" "}
                                  รุ่นรถ
                                </span>
                                <AsyncTypeahead
                                  id="my-typeahead-id1"
                                  {...this.state}
                                  labelKey="model"
                                  selected={this.state.selectedmodel}
                                  onChange={(selectedmodel) =>
                                    this.setState({ selectedmodel })
                                  }
                                  onBlur={this._blurinput}
                                  onSearch={this._handleSearch}
                                  minLength={1}
                                  placeholder="ค้นหารุ่น..."
                                  renderMenuItemChildren={(option, props) => (
                                    <MenuItem key={option}> {option} </MenuItem>
                                  )}
                                  onFocus={() =>
                                    this.setState({ chkfocus: "model" })
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon"> สีรถ</span>

                                <AsyncTypeahead
                                  id="my-typeahead-id2"
                                  {...this.state}
                                  labelKey="color"
                                  selected={this.state.selectedcolor}
                                  onChange={(selectedcolor) =>
                                    this.setState({ selectedcolor })
                                  }
                                  onBlur={this._blurinput}
                                  onSearch={this._handleSearch}
                                  minLength={1}
                                  placeholder="ค้นหาสี..."
                                  renderMenuItemChildren={(option, props) => (
                                    <MenuItem key={option}> {option} </MenuItem>
                                  )}
                                  onFocus={() =>
                                    this.setState({ chkfocus: "color" })
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon">
                                  {" "}
                                  ทะเบียน
                                </span>
                                <input
                                  type="text"
                                  className="form-control "
                                  ref={this.Rnregist}
                                  tabIndex={22}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Panel.Body>
                </Panel>
              </Col>
            </Row>
          </Col>
        </Grid>

        <Snackbar
          place="br"
          color={this.state.color}
          icon={this.state.icon}
          autoClose={this.state.autoClose}
          message={this.state.messagealert}
          open={this.state.opensnackbar}
          closeNotification={() => {
            this.setState({ opensnackbar: false });
          }}
          close
        />
      </div>
    );
  }
}
